import { constants } from "@cinch-nx/data-search";
const { defaultFilters  } = constants;
const arraysContainsEqualValues = (a, b)=>{
    if (a.length !== b.length) {
        return false;
    }
    return a.every((item)=>b.includes(item)) && b.every((item)=>a.includes(item));
};
export const getActiveFilters = (filters)=>Object.entries(filters).reduce((activeFilters, [key, value])=>{
        const filtersKey = key;
        if (!arraysContainsEqualValues(defaultFilters[filtersKey], value)) {
            activeFilters.push(filtersKey);
        }
        return activeFilters;
    }, []);
